import { defaultThemeColors } from './defaultThemeColors';
export var defaultTagVariants = {
    blue: {
        backgroundColor: defaultThemeColors.blue,
        color: defaultThemeColors.blueDark,
    },
    gray: {
        backgroundColor: defaultThemeColors.grey,
        color: defaultThemeColors.greyDark,
    },
    gold: {
        backgroundColor: defaultThemeColors.gold,
        color: defaultThemeColors.goldDark,
    },
    red: {
        backgroundColor: defaultThemeColors.red,
        color: defaultThemeColors.redDark,
    },
    orange: {
        backgroundColor: defaultThemeColors.orange,
        color: defaultThemeColors.orangeDark,
    },
    green: {
        backgroundColor: defaultThemeColors.green,
        color: defaultThemeColors.greenDark,
    },
};
//# sourceMappingURL=defaultTagVariants.js.map